import { LineHeight } from '@hendrx/icons/LineHeight';
import { CSSProperties, ReactNode } from 'react';

import { EditableSelect } from '../../selects/EditableSelect';

type LineHeightPickerProps = {
  value: number;
  onChange: (newValue: number) => void;
  title?: string;
  leftSection?: ReactNode;
  leftSectionWidth?: number;
  inputClassNames?: Record<string, string>;
  style?: CSSProperties;
};

const fontSizeOptions = ['1', '1.15', '1.5', '2', '2.5', '3'];

export function LineHeightPicker(props: LineHeightPickerProps) {
  const { onChange, value, title, leftSection, leftSectionWidth, inputClassNames, style } = props;

  return (
    <EditableSelect
      data={fontSizeOptions}
      value={String(value)}
      setValue={value => {
        onChange(Number(value));
      }}
      type="number"
      title={title}
      leftSection={
        <>
          {leftSection}
          <LineHeight />
        </>
      }
      leftSectionWidth={leftSectionWidth}
      inputClassNames={inputClassNames}
      style={style}
    />
  );
}
